export const MUTATION_TYPES = {
  SET_AUTH: 'auth/SET',
  SET_FLOW_PERCENT: 'flow/setPercent',
};

export const MUTATION_PAYLOAD = {
  STEP1_PERCENT: '50',
  STEP2_PERCENT: '75',
  STEP3_PERCENT: '85',
  STEP4_PERCENT: '90',
  UPLOAD_PHOTO: '95',
};

export const MUTATION_PAYLOAD_KEY = {
  USER: 'user',
};
